<template>
  <div v-if="!loader">
    <b-card class="row-height" no-body>
      <div>
        <b-card no-body class="card-statistics" style="">
          <b-card-body class="statistics-body">
            <h2 class="text-purple font-weight-bold mb-1">
              <b-link class="btn btn-outline-primary btn-sm" to="/">
                <FeatherIcon icon="ChevronLeftIcon"></FeatherIcon>
                {{ $t("back") }}
              </b-link>
              {{ $store.state.auth.user.crole == 'seller' ? $t("billing_information") : $t('activity_report') }}
            </h2>
            <b-row>
              <b-col cols="12" md="6" class="border shadow" v-if="$store.state.auth.user.crole == 'seller' && billing && billing.end_date">
                <div class="d-flex  col-12 mb-1 mt-1">
                  <span class="col-6"><strong>{{ $t("status") }}</strong></span>
                  <span v-if="billing && billing.paid == 1" class="col-6 justify-content-end" align="end">
                    <b-button variant="outline-success" size="sm">
                      {{ $t("active") }}
                      <FeatherIcon
                          size="15"
                          variant="success"
                          icon="CheckIcon"
                      >
                      </FeatherIcon>
                    </b-button>
                  </span>
                </div>
                <div class="d-flex col-12 mb-1">
                  <span class="col-6"><strong>{{ $t("subscription_valid_until") }}</strong></span>
                  <span v-if="billing && billing.end_date" class="col-6 justify-content-end" align="end">{{ billing.end_date | formatDate }}</span>
                </div>
                <div class="d-flex col-12">
                  <span class="col-6" v-if="preregistered">
                    <strong> {{ $t("preregistered") }}</strong>
                  </span>
                </div>
              </b-col>
              <b-col cols="12" md="6" class="border shadow" v-else-if="$store.state.auth.user.crole == 'seller' && billing && billing.end_date == null">
                <div class="d-flex  col-12 mb-1 mt-1">
                  <feather-icon size="21" icon="AlertTriangleIcon"/>
                  <span class="ml-1">
                    {{ $t("14_days_trial") }}
                  </span>
                </div>
              </b-col>
            </b-row>
            <br><br>
            <div v-if="monthly && $store.state.auth.user.crole == 'seller'">
              <b-table hover :items="monthlyData" :fields="monthlyFields" responsive>
                <template #head()="scope">
                  <div class="text-nowrap">{{ $t(scope.label) }}</div>
                </template>

                <template #cell(total)="data">
                  <span>{{ data.value | formatAmount }}</span>
                </template>
                <template #cell(month)="data">
                <span class="badge badge-light-secondary">
                   {{ getMonthName(data.value) }} </span>
                </template>

                <template #cell(pdf)="data">
                <span v-if="data.item.pdf" class="">
                  {{ data.value }}
                  <b-button
                      variant="outline-success"
                      @click="downloadPdf(data.item)"
                      style="font-size:8px !important"
                      size="sm"
                  >
                    <FeatherIcon icon="BookOpenIcon"></FeatherIcon>
                  </b-button>
                </span>
                </template>
              </b-table>
            </div>
            <div v-else>
              <b-form>
                <b-row>
                  <b-col md="5" sm="6">
                    <b-form-group label="Start Date:">
                      <b-form-datepicker :max="new Date()" v-model="startDate" :placeholder="$t('select_date')">></b-form-datepicker>
                    </b-form-group>
                  </b-col>
                  <b-col md="5" sm="6">
                    <b-form-group label="End Date:">
                      <b-form-datepicker :max="new Date()" v-model="endDate"></b-form-datepicker>
                    </b-form-group>
                  </b-col>
                  <b-col md="2" sm="4" class="d-flex">
                    <b-form-group label="" class="mt-md-2 mr-sm-1  pt-md-1">
                      <b-button @click="getReport(afterSearch=true)" variant="primary" size="sm">
                        Search
                      </b-button>
                    </b-form-group>
                    <b-form-group label="" class="mt-md-2 pt-md-1 ">
                      <b-button @click="downloadPdfReport()" variant="primary" size="sm" class="d-flex">
                        <FeatherIcon size="12" icon="DownloadIcon"></FeatherIcon>
                        PDF
                      </b-button>
                    </b-form-group>
                    <b-form-group label="" class="mt-md-2 pt-md-1 ml-1">
                      <b-button @click="downloadCsvReport()" variant="primary" size="sm" class="d-flex">
                        <FeatherIcon size="12" icon="DownloadIcon"></FeatherIcon>
                        CSV
                      </b-button>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
              <b-table hover :items="reportData" :fields="reportFields" responsive v-if="!loaderForTable">
                <template #head()="scope">
                  <div class="text-nowrap">{{ $t(scope.label) }}</div>
                </template>

                <template #cell(investor_id)="data">
                <span class="badge badge-secondary">
                   {{ data.value }} </span>
                </template>

                <template #cell(total)="data">
                  <span>{{ data.value | formatAmount }}</span>
                </template>

                <template #cell(invested_amount_per_invoice)="data">
                  <p style="width: 120px !important;" class="mb-0 pb-0">{{ amountFormat(data.value, data.item.currency) }}</p>
                </template>

                <template #cell(net_return_per_invoice)="data">
                  <p style="width: 120px !important;" class="mb-0 pb-0">{{ amountFormat(data.value, data.item.currency) }}</p>
                </template>

                <template #cell(settlement_date)="data">
                  <span v-if="data.item.settlement_date">{{ data.item.settlement_date }}</span>
                  <span v-else>-</span>
                </template>

                <template #cell(amount)="data">
                  <span v-if="data.item.amount"> {{ amountFormat(data.item.amount, data.item.currency) }} </span>
                  <span v-else>-</span>
                </template>

                <template #cell(liquidity_amount)="data">
                  <span v-if="data.item.liquidity_amount"> {{ amountFormat(data.item.liquidity_amount, data.item.currency) }} </span>
                  <span v-else>-</span>
                </template>

                <template #cell(roi_in_percent)="data">
                  <span v-if="data.item.net_return_per_invoice && data.item.invested_amount_per_invoice ">
                    ~{{ calculateRoiPercent(data.item.net_return_per_invoice, data.item.invested_amount_per_invoice) }}%
                  </span>
                  <span v-else>%</span>
                </template>

                <template #cell(status)="data">
                  <span :class="getStatusClass(data)" class="status-cell">
                    {{ getStatusLabel(data) }}
                  </span>
                </template>

                <template #cell(period)="data">
                  <span class="badge badge-light-secondary">
                     {{ data.value }}
                  </span>
                </template>

              </b-table>
              <div v-else>
                <img src="/new-loader.svg" />
              </div>
              <table class="styled-table">
                <thead>
                <tr>
                  <th></th>
                  <th v-for="(value, currency) in totalSaldos" :key="currency">
                    {{ currency.toUpperCase() }}
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="saldoBalances && totalSaldos">
                  <th scope="row">{{ $t('saldo_balances') }} ({{ endDate }})</th>
                  <td v-for="(value, currency) in totalSaldos" :key="currency + '-saldo'">
                    {{ saldoBalances[currency] !== undefined && saldoBalances[currency] !== null ? amountFormat(saldoBalances[currency], currency) : '-' }}
                  </td>
                </tr>
                <tr>
                  <th scope="row" v-if="$store.state.auth.user.crole === 'seller'">
                    {{ $t('total_sold_amount') }}
                  </th>
                  <th scope="row" v-else>
                    {{ $t('total_investment_amount') }}
                  </th>
                  <td v-for="(value, currency) in totalSaldos" :key="currency + '-amount'">
                    {{ amountFormat(value.total_amount, currency) }}
                  </td>
                </tr>
                <tr v-if="$store.state.auth.user.crole == 'buyer'">
                  <th scope="row">{{ $t('total_net_return') }}</th>
                  <td v-for="(value, currency) in totalSaldos" :key="currency + '-net-return'">
                    {{ amountFormat(value.total_net_return, currency) }}
                  </td>
                </tr>
                <tr v-if="$store.state.auth.user.crole == 'buyer'">
                  <th scope="row">{{ $t('roi_percent') }}</th>
                  <td
                      v-for="(value, currency) in totalSaldos"
                      :key="currency + '-roi'"
                      :class="value.roi_percent >= 0 ? 'roi-positive' : 'roi-negative'"
                  >
                    {{ Number(value.roi_percent || 0).toFixed(2) }}%
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </b-card-body>
        </b-card>
      </div>
    </b-card>
  </div>
  <div v-else>
    <img src="/new-loader.svg"/>
  </div>
</template>
<script>
import {ValidationObserver, ValidationProvider,} from "vee-validate";
import Table from "@/components/common/Table.vue";
import fileDownload from "js-file-download";
import {CurrencyAmountFormat} from '@core/utils/CurrencyAmountFormat';

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    Table
  },
  data() {
    return {
      currency: null,
      totalSaldos: null,
      saldoBalances: null,
      monthly: false,
      company: null,
      billing: null,
      startDate: null,
      endDate: null,
      loader: false,
      loaderForTable: false,
      preregistered: false,
      monthlyData: null,
      monthlyFields: [
        {
          label: "month",
          align: "start",
          key: "month",
        },
        {
          label: "date",
          key: "date",
          sortable: false,
        },
        {
          label: "total",
          align: "start",
          key: "total",
          sortable: false,
        },
        {
          label: "pdf",
          align: "start",
          key: "pdf",
          sortable: false,
        },
      ],
      reportData: null,
      reportDataSeller: null,
      reportDataBuyer: null,
      reportFields: null,
      reportFieldsSeller: [
        {
          label: "account_holder",
          align: "start",
          key: "account_holder",
        },
        {
          label: "id",
          key: "seller_id",
          sortable: false,
        },
        {
          label: "factoring_type",
          align: "start",
          key: "account_type",
        },
        {
          label: "currency",
          align: "start",
          key: "currency",
          sortable: false,
        },
        {
          label: "period",
          align: "start",
          key: "period",
          sortable: false,
        },
        {
          label: "date_of_sale",
          align: "start",
          key: "date_of_sale",
          sortable: false,
        },
        {
          label: "settlement date",
          align: "start",
          key: "settlement_date",
          sortable: false,
        },
        {
          label: "aequitex_invoice_id",
          align: "start",
          key: "aequitex_invoice_id",
          sortable: false,
        },
        {
          label: "reference",
          align: "start",
          key: "reference",
          sortable: false,
        },
        {
          label: "amount",
          align: "start",
          key: "amount",
          sortable: false,
        },
        {
          label: "liquidity_amount",
          align: "start",
          key: "liquidity_amount",
        },
      ],
      reportFieldsBuyer: [
        {
          label: "account_holder",
          align: "start",
          key: "account_holder",
        },
        {
          label: "id",
          key: "investor_id",
          sortable: false,
        },
        {
          label: "factoring_type",
          align: "start",
          key: "account_type",
        },
        {
          label: "currency",
          align: "start",
          key: "currency",
          sortable: false,
        },
        {
          label: "period",
          align: "start",
          key: "period",
          sortable: false,
        },
        {
          label: "date_of_investment",
          align: "start",
          key: "date_of_investment",
          sortable: false,
        },
        {
          label: "settlement date",
          align: "start",
          key: "settlement_date",
          sortable: false,
        },
        {
          label: "status",
          align: "start",
          key: "status",
          sortable: false,
        },
        {
          label: "aequitex_invoice_id",
          align: "start",
          key: "aequitex_invoice_id",
        }, {
          label: "reference",
          key: "reference",
          sortable: false,
        },
        {
          label: "amount",
          align: "start",
          key: "invested_amount_per_invoice",
          sortable: false,
        },
        {
          label: "net_return",
          align: "start",
          key: "net_return_per_invoice",
          sortable: false,
        },
        {
          label: "roi in percent",
          align: "start",
          key: "roi_in_percent",
          sortable: false,
        },
      ],
      today: new Date().toISOString().split('T')[0],
    };
  },
  created() {
    this.getData();
    this.getBilling();
    this.getMonthlyData();
  },
  methods: {

    getStatusLabel(data) {
      let status = data.value;
      let text;

      if (status === 10) {
        if (this.today > data.item.due_date) {
          text = this.$t('overdue');
        } else {
          text = this.$t('purchased');
        }
      } else if (status === 11) {
        text = this.$t('settled');
      } else if (status === 13) {
        text = this.$t('invoice_default');
      } else {
        text = '-';
      }

      return text;
    },

    getStatusClass(data) {
      let status = data.value;
      let color = 'text-warning';

      if (status === 10) {
        if (this.today > data.item.due_date) {
          color = 'text-warning';
        } else {
          color = 'text-info';
        }
      } else if (status === 11) {
        color = 'light-green';
      } else if (status === 13) {
        color = 'text-danger';
      } else {
        color = 'text-primary';
      }

      return color;
    },

    calculateRoiPercent(net_return, amount) {
      const finalRoiPercent = net_return * 100 / amount

      return Number(parseFloat(finalRoiPercent).toFixed(2));
    },

    amountFormat(amount, currency) {
      return CurrencyAmountFormat(amount, currency)
    },

    downloadPdfReport() {
      let url = '';
      let payload = '';
      if (this.$store.state.auth.user.crole == 'seller') {
        url = '/report/seller/pdf';
        payload = {
          company_id: this.$store.state.auth.user.company_id,
          startDate: this.startDate,
          endDate: this.endDate
        }
      } else if (this.$store.state.auth.user.crole == 'buyer') {
        url = '/buyer/report/pdf';
        payload = {
          startDate: this.startDate,
          endDate: this.endDate
        }
      }
      this.$http
          .post(url, payload, {responseType: "blob",})
          .then((response) => {
            fileDownload(response.data, 'report.pdf');
          })
          .catch((error) => {
          });
    },
    downloadPdf(item) {
      this.$http
          .post(
              "/company/invoiceForSeller/downloadInvoiceForSeller/" + item.id,
              {},
              {
                responseType: "blob",
              }
          )
          .then((response) => {
            fileDownload(response.data, 'monthly.pdf');
          })
          .catch((error) => {
          });
    },
    downloadCsvReport() {
      let url = '';
      let payload = '';
      if (this.$store.state.auth.user.crole == 'seller') {
        url = '/report/seller/csv';
        payload = {
          company_id: this.$store.state.auth.user.company_id,
          startDate: this.startDate,
          endDate: this.endDate
        }
      } else if (this.$store.state.auth.user.crole == 'buyer') {
        url = '/buyer/report/csv';
        payload = {
          startDate: this.startDate,
          endDate: this.endDate
        }
      }
      this.$http
          .post(url, payload, {responseType: "blob",})
          .then((response) => {
            let filename = 'report';
            filename += '.csv';
            if (window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveBlob(response.data, filename);
            } else {
              const link = document.createElement('a');
              link.href = URL.createObjectURL(response.data);
              link.setAttribute('download', filename);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          })
          .catch((error) => {
          });
    },
    getMonthName(monthNumber) {
      const currentLanguage = this.$store.state.app.language;
      const months = {
        'en': [
          "January", "February", "March", "April",
          "May", "June", "July", "August",
          "September", "October", "November", "December"
        ],
        'de': [
          "Januar", "Februar", "März", "April",
          "Mai", "Juni", "Juli", "August",
          "September", "Oktober", "November", "Dezember"
        ]
      };
      const index = Math.min(Math.max(parseInt(monthNumber, 10), 1), 12) - 1;
      return months[currentLanguage][index];
    },
    getData() {
      this.loader = true;
      this.$http
          .post(`/company/show/${this.$store.state.auth.user.company_id}`)
          .then((res) => {
            if (res) {
              this.company = res.data.value;
              if (res.data.value.buyer == 1) {
                this.reportFields = this.reportFieldsBuyer;
              } else if (res.data.value.buyer == 0) {
                this.reportFields = this.reportFieldsSeller;
              }
              this.loader = false;
            }
          });
    },
    getBilling() {
      this.$http
          .post(`/company/billing/get`, {company_id: this.$store.state.auth.user.company_id})
          .then((res) => {
            if (res) {
              this.billing = res.data.value;

              let date = new Date();
              date = date.toISOString().split('T')[0]

              this.endDate = date;

              this.getReport();
            }
          });
    },
    getMonthlyData() {
      if (this.$store.state.auth.user.crole == 'seller') {
        this.$http
            .post(`/company/invoiceForSeller/index`, {company_id: this.$store.state.auth.user.company_id})
            .then((res) => {
              if (res) {
                this.monthlyData = res.data.value;
              }
            });
      } else if (this.$store.state.auth.user.crole == 'buyer') {
        this.$http
            .post(`/company/invoiceForSeller/index`, {company_id: this.$store.state.auth.user.company_id})
            .then((res) => {
              if (res) {
                this.monthlyData = res.data.value;
              }
            });
      }
    },
    getReport(afterSearch) {
      if (this.$store.state.auth.user.crole == 'seller') {
        this.getReportDataSeller(afterSearch);
      } else if (this.$store.state.auth.user.crole == 'buyer') {
        this.getReportDataBuyer(afterSearch);
      }
      this.getSaldoBalances();
    },
    getReportDataSeller(afterSearch = false) {
      this.loaderForTable = true;
      let data = {
        company_id: this.$store.state.auth.user.company_id,
        startDate: this.startDate,
        endDate: this.endDate,
      }
      this.$http
          .post(`/report/seller`, data)
          .then((res) => {
            if (res && res.data.value && res.data.value.length > 0) {
              this.totalSaldos = res.data.value[0]?.total_liquidity_amount;
              this.reportData = res.data.value.slice(1);
              this.currency = this.reportData[0].currency
            } else if (afterSearch) {
              this.totalSaldos = 0;
              this.reportData = [];
              this.currency = null;
              this.$swal({
                position: "center",
                icon: "warning",
                title: this.$t('no_invoices_sold_for_the_required_period'),
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
              });
            }
            this.loaderForTable = false;
          });
    },
    getReportDataBuyer(afterSearch) {
      let data = {
        startDate: this.startDate,
        endDate: this.endDate,
      }
      this.$http
          .post(`/buyer/report`, data)
          .then((res) => {
            if (res && res.data.value) {
              this.reportData = res.data.value.slice(1);
              this.currency = this.reportData[0].currency
              this.totalSaldos = res.data.value[0].total_saldos;
            } else if (afterSearch) {
              this.$swal({
                position: "center",
                icon: "warning",
                title: this.$t(res.data.message),
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
              });
            }
          });
    },
    showSuccessMessage(message, type) {
      let text = this.$t(message);
      this.$swal({
        position: "center",
        icon: "success",
        title: text,
        showConfirmButton: false,
        timer: 1500,
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    getSaldoBalances() {
      if (!this.endDate) {
        return;
      }

      let payload = {
        endDate: this.endDate
      };

      if (this.$store.state.auth.user.crole == 'seller') {
        payload.company_id = this.$store.state.auth.user.company_id;
      }

      this.$http.post('/company/daily-transactions/saldo-balances', payload)
          .then((res) => {
            if (res && res.data.value) {
              this.saldoBalances = res.data.value;
            }
          })
          .catch((error) => {
            console.error('Error fetching saldo balances:', error);
          });
    },

  },
};
</script>
<style scoped>
.styled-table {
  margin-top: 50px;
  border-collapse: collapse;
  font-size: 16px;
  width: 100%;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
}

.styled-table thead tr {
  background-color: #798581;
  color: #ffffff;
  text-align: center;
  font-weight: bold;
}

.styled-table th,
.styled-table td {
  padding: 12px 15px;
  border: 1px solid #dee2e6;
  text-align: center;
}

.styled-table tbody tr:nth-child(even) {
  background-color: #f3f3f3;
}

.styled-table tbody tr:hover {
  background-color: #e9ecef;
}

.status-cell {
  width: fit-content !important;
  min-width: fit-content !important;
  white-space: nowrap;
}
</style>
